class SelfUserPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'self.*';

    // Can manage own occupancy settings
    static OCCUPANCY_MANAGE = 'self.occupancy.manage';

    // Can update own main info
    static INFO_UPDATE = 'self.info.update';

    // Can manually update own email
    static EMAIL_UPDATE_MANUAL = 'self.email.update.manual';

    // Can use UserEmailChange flow to update email
    static EMAIL_UPDATE_FLOW = 'self.email.update.flow';

    // Can manually manage own verification status
    static VERIFICATION_MANAGE = 'self.verification.manage';

    // Can initiate and use user verification flow
    static VERIFICATION_FLOW = 'self.verification.flow';

    // Can shut down self
    static SHUTDOWN = 'self.shutdown';

    // Can set up Google auth
    static AUTH_GOOGLE_SETUP = 'self.auth.google.setup';

    // Can remove Google auth
    static AUTH_GOOGLE_REMOVE = 'self.auth.google.remove';

    // Can set up password auth
    static AUTH_PASSWORD_SETUP = 'self.auth.password.setup';

    // Can remove password auth
    static AUTH_PASSWORD_REMOVE = 'self.auth.password.remove';

    // Can update password with confirmation
    static AUTH_PASSWORD_UPDATE = 'self.auth.password.update';

    // Can manually apply new password without confirmation
    static AUTH_PASSWORD_UPDATE_FORCED = 'self.auth.password.update.forced';

    // Can manage own auth role
    static AUTH_ROLE_MANAGE = 'self.auth_role.manage';
}

export default SelfUserPermission;
